import { gql, type QueryHookOptions, useQuery } from "@apollo/client";

const QUERY = gql`
  query bookings {
    bookings(time: UPCOMING, status: BOOKED) {
      id
      currency
      datetime
      datetimeOffset
      game {
        id
        cacheKey
        gameimageSet {
          id
          imageId
        }
        location {
          id
          cacheKey
          company {
            id
            name
          }
          displayName
        }
        name
      }
      total
    }
  }
`;

interface GameType {
  cacheKey?: string;
  gameimageSet: {
    id: string;
    imageId: string;
  }[];
  id: string;
  location: {
    id: string;
    cacheKey?: string;
    company: {
      id: string;
      name: string;
    };
    displayName: string;
  };
  name: string;
}

export interface BookingType {
  currency?: string;
  datetime: string;
  datetimeOffset: number;
  game: GameType;
  id: string;
  total: number;
}

interface DataType {
  bookings: BookingType[];
}

export default function useUpcomingBookings(options?: QueryHookOptions) {
  return useQuery<DataType>(QUERY, options);
}
